<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div v-on:keyup.enter="buildNewSearch">
    <v-layout align-center justify-center row>
      <v-flex xs2>
        <v-text-field
          browser-autocomplete="off"
          class="ma-2"
          v-model="searchedFields.projectCode"
          label="Nr projektu"
          aria-label="project code"
          for="project-table-project-code"
          id="project-table-project-code"
        ></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-autocomplete
          clearable
          class="ma-2"
          label="Nazwa konkursu"
          v-model="searchedFields.contestName"
          aria-label="contest name"
          for="project-table-contest-name"
          id="project-table-contest-name"
          :items="contestNameList"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs2>
        <v-autocomplete
          class="ma-2"
          v-model="searchedFields.realizationYear"
          :items="yearList"
          label="Rok realizacji"
          aria-label="realization year"
          for="project-table-realization-year"
          id="project-table-realization-year"
          clearable
        ></v-autocomplete>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center row>
      <v-flex xs4>
        <v-autocomplete
          class="ma-2"
          v-model="searchedFields.mainCountryId"
          :items="countryList"
          item-text="name"
          item-value="id"
          aria-label="main country"
          label="Kraj główny projektu"
          for="project-table-main-country"
          id="project-table-main-country"
          clearable
        ></v-autocomplete>
      </v-flex>
      <v-flex xs4>
        <v-layout align-center justify-center>
          <v-btn @click="buildNewSearch" color="primary" dark class="ma-2"
            >Szukaj</v-btn
          >
          <v-btn @click="resetSearch" color="primary" dark class="ma-2"
            >Resetuj</v-btn
          >
          <v-btn @click="exportData" color="primary" dark class="ma-2"
            >Eksportuj</v-btn
          >
        </v-layout>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="dataTable.headers"
      :rows-per-page-items="[10, 20, 25]"
      :loading="loading"
      :items="dataTable.itemList"
      :total-items="dataTable.itemCount"
      :pagination.sync="dataTable.pagination"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr :class="{ 'primary--text': props.item.mutualProject }">
          <td>
            <v-layout row>
              <v-flex shrink>
                {{ props.item.projectCode }}
              </v-flex>
              <v-flex v-if="props.item.mutualProject" pl-1 grow>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">groups</v-icon>
                  </template>
                  <div>
                    <div>Oferent główny: {{ props.item.mainBidderName }}</div>
                    <div>Projekt wspólny z: {{ props.item.mutualBidderNames.join(", ") }}</div>
                  </div>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-tooltip
              bottom
              v-if="
                props.item.finalReportStatus === 'REQUESTED_CHANGES' &&
                  (roles.isBidder() || roles.isSubBidder())
              "
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  :color="getStatusByReportColor(props.item.finalReportStatus)"
                  v-on="on"
                  style="margin-left: 5px"
                >
                  warning
                </v-icon>
              </template>
              <div>
                <div>
                  <b>Sprawozdanie końcowe do poprawki</b>
                </div>
                {{ props.item.finalReportCorrectionCause }}
              </div>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="
                props.item.status === 'WITHDRAWN' &&
                  (roles.isBidder() || roles.isSubBidder())
              "
            >
              <template v-slot:activator="{ on }">
                <v-icon color="red" v-on="on" style="margin-left: 5px">
                  cancel
                </v-icon>
              </template>
              <div>
                <div>
                  <b>Projekt anulowany</b>
                </div>
                {{ props.item.withdrawalCause }}
              </div>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="
                props.item.status === 'REQUESTED_CHANGES' &&
                  (roles.isBidder() || roles.isSubBidder())
              "
            >
              <template v-slot:activator="{ on }">
                <v-icon color="warning" v-on="on" style="margin-left: 5px">
                  warning
                </v-icon>
              </template>
              <div>
                <div>
                  <b>Projekt do poprawki</b>
                </div>
                <div>
                  <b>{{ props.item.correctionCause }}</b>
                </div>
                {{ props.item.detailedCorrectionCause }}
              </div>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="
                props.item.finalReportStatus === 'APPROVED' &&
                  (roles.isBidder() || roles.isSubBidder())
              "
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  :color="getStatusByReportColor(props.item.finalReportStatus)"
                  v-on="on"
                  style="margin-left: 5px"
                >
                  done_all
                </v-icon>
              </template>
              <span>Zatwierdzono sprawozdanie końcowe</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="
                (props.item.finalReportStatus === 'SENT' ||
                  props.item.finalReportStatus === 'CHANGES_SENT') &&
                  (roles.isBidder() || roles.isSubBidder())
              "
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  :color="getStatusByReportColor(props.item.finalReportStatus)"
                  v-on="on"
                  style="margin-left: 5px"
                >
                  check
                </v-icon>
              </template>
              <span>Wysłano sprawozdanie końcowe</span>
            </v-tooltip>
                        <v-tooltip
              bottom
              v-if="
                props.item.status === 'FINISHED' &&
                  (roles.isBidder() || roles.isSubBidder())
              "
            >
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" style="margin-left: 5px">
                  done_all
                </v-icon>
              </template>
              <span>
                  <b>Projekt zakończony</b>
              </span>
            </v-tooltip>
          </td>
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.contestName }}</td>
          <td>{{ props.item.countries.join(", ") }}</td>
          <td>{{ formatMoney(props.item.projectValue) }}</td>
          <td>{{ formatMoney(props.item.donation) }}</td>
          <td>
            <v-layout>
              <egranty-icon-button
                v-if="props.item.supervisorName"
                icon="person"
                :label="props.item.supervisorName"
              ></egranty-icon-button>
            </v-layout>
          </td>
          <td>
            <v-layout>

              <egranty-icon-button
          v-if="(props.item.listOfUsersToGivePrivillages 
					&& props.item.listOfUsersToGivePrivillages.length >0)"
						icon="person"
						color="blue"
						label="Przekaż uprawnienia"
						for="my-contest-offer-list-view-confirm"
						id="my-contest-offer-list-view-confirm"
						@click="showDialogWithUsers(props.item)"/>

            <egranty-icon-button
                v-if="props.item.canManageProject"
                icon="info"
                color="primary"
                :label="showCanManageProjectUserText(props.item)"
                for="project-manage-info"
                id="project-manage-info"
              />

              <egranty-icon-button
                v-if="projectEditAllowed(props.item)"
                :disabled="props.item.isArchived === false"
                @click="navigateToEdit(props.item.id)"
                icon="edit"
                label="Edycja"
                for="project-table-edit"
                id="project-table-edit"
              ></egranty-icon-button>

              <egranty-icon-button
                v-if="
                  projectAcceptRejectAllowed(props.item)
                "
                icon="send"
                color="blue"
                label="Zatwierdź"
                for="my-contest-offer-list-view-confirm"
                id="my-contest-offer-list-view-confirm"
                @click="acceptSubBidderProject(props.item.id)"
              ></egranty-icon-button>


              <egranty-icon-button
                v-if="
                  projectAcceptRejectAllowed(props.item)
                "
                icon="close"
                color="blue"
                label="Odrzuć"
                for="my-contest-offer-list-view-reject"
                id="my-contest-offer-list-view-reject"
                @click="rejectSubBidderProject(props.item.id)"
              ></egranty-icon-button>

              <egranty-icon-button
                v-if="!props.item.hideFromUser"
                @click="navigateToView(props.item.id)"
                icon="description"
                :color="getProjectStatusIconColor(props.item.status)"
                :label="'Podgląd ' + getProjectStatusLabel(props.item.status)"
                for="project-table-preview"
                id="project-table-preview"
              ></egranty-icon-button>

              <egranty-icon-button
                v-if="
                  ['REQUESTED_CHANGES'].includes(props.item.status) &&
                    (roles.isBidder() || roles.isSubBidder()) &&
                    !props.item.hideFromUser
                "
                @click="navigateToCompare(props.item.id)"
                icon="compare_arrows"
                label="Wyświetl zmiany"
                for="project-table-display-changes"
                id="project-table-display-changes"
              ></egranty-icon-button>
              <egranty-icon-button
                v-if="
                  ['AGREEMENT_SIGNED', 'FINISHED'].includes(props.item.status) &&
                    (roles.isBidder() || roles.isSubBidder()) &&
                    !props.item.hideFromUser &&
                    props.item.financialDocumentsIncluded
                "
                @click="navigateToInvoices(props.item.id)"
                icon="receipt"
                color="blue darken-3"
                label="Dokumenty finansowe"
                for="project-table-finance-documents"
                id="project-table-finance-documents"
              ></egranty-icon-button>

              <egranty-icon-button
                v-if="
                  !props.item.hideFromUser &&
                    (props.item.status === 'APPROVED' ||
                      props.item.status === 'AGREEMENT_SIGNED' || 
                      props.item.status === 'FINISHED') &&
                      (finalReportEditAllowed(props.item) ||
                      ['SENT', 'APPROVED', 'CHANGES_SENT', 'POST_CORRECTION_MAIN', 'FINISHED']
                      .includes(props.item.finalReportStatus))
                    "
                :color="getStatusByReportColor(props.item.finalReportStatus)"
                @click="navigateToFinalReport(props.item)"
                icon="insert_chart"
                :label="
                  'Sprawozdanie końcowe ' +
                    getFinalReportStatusLabel(props.item.finalReportStatus)
                "
              ></egranty-icon-button>

              <egranty-icon-button
                icon="send"
                color="primary lighten-1"
                label="Zaakceptuj sprawozdanie"
                for="report-accept"
                id="report-accept"
                @click="acceptSubBidderReport(props.item.id)"
                v-if="finalReportAcceptOrRejectAllowed(props.item)"
              />

              

              <egranty-icon-button
                icon="close"
                color="primary lighten-1"
                label="Odrzuć sprawozdanie"
                for="report-reject"
                id="report-reject"
                @click="rejectSubBidderReport(props.item.id)"
                v-if="finalReportAcceptOrRejectAllowed(props.item)"
              />

              <egranty-icon-button
          v-if="(props.item.listOfUsersToGiveFinalReportPrivillages 
					&& props.item.listOfUsersToGiveFinalReportPrivillages.length >0)"
						icon="person"
						color="blue"
						label="Przekaż uprawnienia do sprawozdania końcowego"
						for="final-report-privileges"
						id="final-report-privileges"
						@click="showDinalReportDialogWithUsers(props.item)"/>

              <egranty-icon-button
                icon="upload_file"
                color="primary"
                label="Dołącz podpisane sprawozdanie"
                for="report-signed"
                id="report-signed"
                @click="showDialog(props.item.id)"
                v-if="roles.isBidder() && props.item.canAddSignedReportFile"
              />

              <egranty-icon-button
                icon="file_download"
                color="primary"
                label="Pobierz podpisane sprawozdanie"
                for="report-signed-download"
                id="report-signed-download"
                @click="navigateToFinalReportSigned(props.item)"
                v-if="
                  roles.isBidder() && props.item.canDownloadSignedReportFile
                "
              />
              
              <egranty-icon-button
                v-if="props.item.canManageFinalReport"
                icon="info"
                color="primary"
                :label="showCanManageFinalReportUserText(props.item)"
                for="report-manage-info"
                id="report-manage-info"
              />
            </v-layout>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-form ref="form">
          <v-card-title class="headline"
            >Dodawanie podpisanego sprawozdania</v-card-title
          >
          <v-card-text>
            <span class="caption" style="display: block;">
              <b> Dodaj plik z podpisanym sprawozdaniem końcowym.</b>
            </span>
            <span class="caption" style="display: block;">
              <b> Uwaga: zapisanego pliku nie będzie można skasować.</b>
            </span>
            <input
              type="file"
              :accept="acceptedFiles"
              v-show="false"
              ref="signedFinalReport"
              id="signedFinalReport"
              v-on:change="addSignedReportFile"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="$refs.signedFinalReport.click()"> Dodaj plik </v-btn>
            <v-btn @click="dialog = false"> Zamknij </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="confirmationDialog" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Dodawanie podpisanego sprawozdania</span>
        </v-card-title>
        <v-card-text>
          <span class="caption" style="display: block;">
            <b> Dodaj plik z podpisanym sprawozdaniem końcowym.</b>
          </span>
          <span class="caption" style="display: block;">
            <b> Uwaga: zapisanego pliku nie będzie można skasować.</b>
          </span>
          <div v-if="this.$refs.signedFinalReport" class="mt-2 ml-3">
            <div
              v-for="(item, index) in this.$refs.signedFinalReport.files"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="handleFileUpload"> Dodaj plik </v-btn>
          <v-btn @click="cancelUpload"> Anuluj </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <egranty-autocomplete
			class="no-print"
			style="background-color: primary"
			:is-visible.sync="dialogUserPrivillages.show"
			:headers="dialogUserPrivillages.headers"
			:possibilities="dialogUserPrivillages.users"
			title="Przekaż prawa do edycji projektu"
			hint=""
			search-field-label="Wybierz użytkownika"
			:description="(x) => x.name"
			@cancel="dialogUserPrivillages.show = false"
			@save="givePrivillagesToAnotherUser"
		></egranty-autocomplete>
    <egranty-autocomplete
			class="no-print"
			style="background-color: primary"
			:is-visible.sync="dialogFinalReportUserPrivillages.show"
			:headers="dialogFinalReportUserPrivillages.headers"
			:possibilities="dialogFinalReportUserPrivillages.users"
			title="Przekaż prawa do edycji sprawozdania końcowego"
			hint=""
			search-field-label="Wybierz użytkownika"
			:description="(x) => x.name"
			@cancel="dialogFinalReportUserPrivillages.show = false"
			@save="giveFinalReportPrivillagesToAnotherUser"
		></egranty-autocomplete>
  </div>
</template>

<script>
import { Api } from "@/api";
import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
import { Project } from "@/api/generated/Project";
import { Numbers } from "@/utils/Numbers";
import { AccreditationCountry } from "@/api/generated/AccreditationCountry";
import { ContestRealizationYear } from "@/api/generated/ContestRealizationYear";
import { Pagination } from "@/utils/PaginationUtils";
import { ExportUtils } from "@/utils/ExportUtils";
import { FinalReport } from "@/api/generated/FinalReport";
import { Filters } from "@/utils/Filters";
import { Files } from "@/utils/Files";
import EgrantyAutocomplete from "../../../../genericComponents/EgrantyAutocomplete";


export default {
  name: "ProjectListTable",

  components: {
    EgrantyIconButton,EgrantyAutocomplete
  },

  mixins: [Numbers, Filters, Files],

  methods: {
    showCanManageFinalReportUserText(project){
      return "Użytkownik " + project.canManageFinalReport + " aktualnie zarządza sprawozdaniem końcowym";
    },
    showCanManageProjectUserText(project){
      return "Użytkownik " + project.canManageProject + " aktualnie zarządza projektem";
    },
    showDialogWithUsers(project){
				this.dialogUserPrivillages.show = true;
				this.dialogUserPrivillages.users = project.listOfUsersToGivePrivillages;
				this.dialogUserPrivillages.projectId = project.id;
			},
			givePrivillagesToAnotherUser(user){
				Project.postGivePrivillages(this, this.dialogUserPrivillages.projectId,user.id, () => {
					this.getItemList();
					this.dialogUserPrivillages.show = false;
					this.dialogUserPrivillages.users = [];
					this.dialogUserPrivillages.projectId = null;
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się nadać uprawnień", errorResponse);
				});
			},
      showDinalReportDialogWithUsers(project){
				this.dialogFinalReportUserPrivillages.show = true;
				this.dialogFinalReportUserPrivillages.users = project.listOfUsersToGiveFinalReportPrivillages;
				this.dialogFinalReportUserPrivillages.projectId = project.id;
			},
      giveFinalReportPrivillagesToAnotherUser(user){
				FinalReport.postGivePrivillages(this, this.dialogFinalReportUserPrivillages.projectId,user.id, () => {
					this.getItemList();
					this.dialogFinalReportUserPrivillages.show = false;
					this.dialogFinalReportUserPrivillages.users = [];
					this.dialogFinalReportUserPrivillages.projectId = null;
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się nadać uprawnień", errorResponse);
				});
			},  
    async navigateToFinalReportSigned(item) {
      await this.downloadFileAsBlob(
        this,
        this.getSignedProjectFile(item.id),
        item.signedReportFileName
      );
    },
    async handleFileUpload() {
      this.confirmationDialog = false;
      let formData = new FormData();
      formData.append("file", this.$refs.signedFinalReport.files[0]);
      await this.$http.post(
        process.env.VUE_APP_API_URL +
          "/project/signed-report-file?projectId=".concat(
            this.projectIdInDialog
          ),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      this.getItemList();
    },
    cancelUpload() {
      Files.methods.clearFileInput("signedFinalReport");
      this.confirmationDialog = false;
    },
    async addSignedReportFile() {
      if (this.hasIncorrectFilesExtension(this.$refs.signedFinalReport.files)) {
        Files.methods.clearFileInput("signedFinalReport");
        this.$messagesBus.$emit(
          "error",
          "Wgrywanie plików w tym formacie jest niedozwolone. " +
            "Dozwolone formaty plików to " +
            this.acceptedFiles.split(",").join(", ")
        );
        return;
      }
      let validFilesSize = await Files.methods.validateFilesSize(
        this,
        this.$refs.signedFinalReport.files
      );
      if (!validFilesSize) {
        Files.methods.clearFileInput("signedFinalReport");
        return;
      }
      this.confirmationDialog = true;
      this.dialog = false;
    },
    showDialog(projectId) {
      Files.methods.clearFileInput("signedFinalReport");
      this.dialog = true;
      this.projectIdInDialog = projectId;
    },
    getItemList() {
      if (this.volunteer) {
        this.getVolunteerItemList();
        return;
      }
      let sort = this.buildSort();
      Api.get(
        this,
        "/project/list?search=" +
          this.search +
          "&page=" +
          this.dataTable.pagination.page +
          "&result=" +
          this.dataTable.pagination.rowsPerPage +
          "&sort=".concat(sort),
        (response) => {
          this.dataTable.itemList = response.itemList;
          this.dataTable.itemCount = response.itemCount;
          this.contestNameList = [
            ...new Set(response.itemList.map((item) => item.contestName)),
          ].sort();
        }
      );
    },

    buildNewSearch() {
      if (this.$route.params.bidderId && !this.roles.isSubBidder()) {
        this.searchedFields.bidderId = this.$route.params.bidderId;
      }
      this.search = this.buildSearch();
      this.getItemList();
    },

    buildSearch() {
      return Pagination.buildSearchCriteria(this.searchedFields, false);
    },

    resetSearch() {
      Pagination.resetSearch(this.searchedFields);
      if (this.$route.params.bidderId && !this.roles.isSubBidder()) {
        this.searchedFields.bidderId = this.$route.params.bidderId;
      }
      this.search = this.buildSearch();
      this.getItemList();
    },

    buildSort() {
      let order =
        this.dataTable.pagination.descending === true ? "desc" : "asc";
      let columnName = this.dataTable.pagination.sortBy;
      if (order && columnName) {
        return columnName.concat(" ").concat(order);
      } else {
        return "";
      }
    },

    exportData() {
      let search = this.search;
      let sort = this.buildSort();
      let endpointMainPath = "project";
      let path =
        "/" +
        endpointMainPath +
        "/export?search=" +
        search +
        "&sort=".concat(sort);
      ExportUtils.sendExportRequest(path, this);
    },

    getVolunteerItemList() {
      Project.getVolunteerProjects(
        this,
        this.$route.params.volunteerId,
        (response) => {
          this.dataTable.itemList = response;
          this.dataTable.itemCount = response.length;
        }
      );
    },

    navigateToEdit(projectId) {
      this.$router.push("/app/project/" + projectId);
    },

    navigateToView(projectId) {
      this.$router.openInNewTab("/view/project/" + projectId);
    },

    navigateToCompare(projectId) {
      this.$router.openInNewTab("/view/project/" + projectId + "/compare");
    },

    navigateToInvoices(projectId) {
      this.$router.push("/app/project/" + projectId + "/invoices");
    },

    // finalReportEditAllowed(project) {
    //   return (
    //     (project.finalReportStatus === "POST_CORRECTION_MAIN" &&
    //       this.roles.isBidder() &&
    //       project.allowReportMainBidderChanges) ||
    //     ((project.finalReportStatus === "NEW" ||
    //       project.finalReportStatus === "REQUESTED_CHANGES") &&
    //       (this.roles.isBidder() || this.roles.isSubBidder()))
    //   );
    // },

    projectAcceptRejectAllowed(project){
      return project.acceptAllowed;
    },
    projectEditAllowed(project) {
      return project.editAllowed;
      // if (project.hideFromUser) {
      //   return false;
      // }
      // if (this.roles.isBidder()) {
      //   return (
      //     project.status === "REQUESTED_CHANGES" ||
      //     (project.status === "POST_CORRECTION_MAIN" &&
      //       project.createdBySubbidder &&
      //       project.allowMainBidderChanges)
      //   );
      // }
      // if (this.roles.isSubBidder()) {
      //   return project.status === "REQUESTED_CHANGES";
      // }
    },

    finalReportEditAllowed(project){
      return project.editFinalReportAllowed;
    },

    finalReportAcceptOrRejectAllowed(project){
         return project.acceptFinalReportAllowed;
    },

    navigateToFinalReport(project) {
      if (this.finalReportEditAllowed(project)) {
        this.$router.push("/app/project/" + project.id + "/final-report");
      } else {
        this.$router.openInNewTab({
          path: "/view/project/" + project.id + "/final-report",
        });
      }
    },

    acceptSubBidderReport(projectId) {
      FinalReport.putAccept(
        this,
        projectId,
        () => {
          this.getItemList();
        },
        (errorResponse) => {
          this.$messagesBus.$emit(
            "error",
            "Nie udało się zatwierdzić sprawozdania projektu",
            errorResponse
          );
        }
      );
    },

    rejectSubBidderReport(projectId) {
      this.$confirm(
        "Czy na pewno chcesz odrzucić sprawozdanie projektu? Jeżeli podpisany plik sprawozdania końcowego został załączony do projektu, to zostanie on usunięty.",
        {
          color: "blue",
          icon: "warning",
          title: "Odrzucenie sprawozdania projektu",
          width: 600,
        }
      ).then((response) => {
        if (response) {
          FinalReport.putReject(
            this,
            projectId,
            () => {
              this.getItemList();
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się odrzucić sprawozdania projektu",
                errorResponse
              );
            }
          );
        }
      });
    },

    acceptSubBidderProject(projectId) {
      Project.putAccept(
        this,
        projectId,
        () => {
          this.getItemList();
        },
        (errorResponse) => {
          this.$messagesBus.$emit(
            "error",
            "Nie udało się zatwierdzić projektu",
            errorResponse
          );
        }
      );
    },

    rejectSubBidderProject(projectId) {
      this.$confirm(
        "Czy na pewno chcesz odrzucić projekt? Jeżeli podpisany plik sprawozdania końcowego został załączony do projektu, to zostanie on usunięty.",
        {
          color: "blue",
          icon: "warning",
          title: "Odrzucenie projektu",
          width: 600,
        }
      ).then((response) => {
        if (response) {
          Project.putReject(
            this,
            projectId,
            () => {
              this.getItemList();
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się odrzucić projektu",
                errorResponse
              );
            }
          );
        }
      });
    },

    getCountryList() {
      AccreditationCountry.get(
        this,
        (successResponse) => {
          this.countryList = successResponse;
        },
        (errorResponse) => {
          this.$messagesBus.$emit(
            "error",
            "Nie udało się załadować krajów",
            errorResponse
          );
        }
      );
    },

    getYearList() {
      ContestRealizationYear.getList(
        this,
        (successResponse) => {
          this.yearList = successResponse.items.map((item) => item.value);
          this.yearList.sort(function(x, y) {
            return y - x;
          });
        },
        (errorResponse) => {
          this.$messagesBus.$emit(
            "error",
            "Nie udało się załadować lat realizacji projektów",
            errorResponse
          );
        }
      );
    },

    getStatusByReportColor(finalReportStatus) {
      switch (finalReportStatus) {
        case "REQUESTED_CHANGES":
          return "warning";
        case "APPROVED":
          return "#3e8e41 !important";
        default:
          return "primary";
      }
    },

    getProjectStatusLabel(status) {
      switch (status) {
        case "NEW":
          return "(nowy)";
        case "APPROVED":
          return "(zaakceptowany)";
        case "REQUESTED_CHANGES":
          return "(do poprawki)";
        case "POST_CORRECTION_MAIN":
          return "(oczekuje na akceptację)";
        case "CORRECTED":
          return "(poprawiony)";
        case "AGREEMENT_SIGNED":
          return "(umowa podpisana)";
        case "WITHDRAWN":
          return "(anulowany)";
        case "FINISHED":
          return "(zakończony)";
        default:
          return "";
      }
    },

    getProjectStatusIconColor(status) {
      switch (status) {
        case "NEW":
          return "primary";
        case "APPROVED":
          return "#3e8e41 !important";
        case "REQUESTED_CHANGES":
          return "warning";
        case "POST_CORRECTION_MAIN":
          return "warning";
        case "CORRECTED":
          return "primary";
        case "AGREEMENT_SIGNED":
          return "#3e8e41 !important";
        case "WITHDRAWN":
          return "error";
        case "FINISHED":
          return "#3e8e41 !important";
        default:
          return "";
      }
    },

    getFinalReportStatusLabel(finalReportStatus) {
      switch (finalReportStatus) {
        case "APPROVED":
          return "(zatwierdzone)";
        case "SENT":
          return "(wysłane)";
        case "CHANGES_SENT":
          return "(poprawione)";
        case "REQUESTED_CHANGES":
          return "(do poprawki)";
        case "POST_CORRECTION_MAIN":
          return "(oczekuje na akceptację)";
        case "NEW":
        default:
          return "";
      }
    },
  },

  created() {
    if (this.$route.params.bidderId && !this.roles.isSubBidder()) {
      this.searchedFields.bidderId = this.$route.params.bidderId;
    }
    this.getCountryList();
    this.getYearList();
    this.searchedFields = this.retrieveFilters(this.searchedFields);
    this.dataTable.pagination = this.retrievePagination(
      this.dataTable.pagination
    );
  },

  data() {
    return {
      dataTable: {
        headers: [
          { text: "Nr projektu", value: "code", sortable: true },
          { text: "Nazwa projektu", value: "title", sortable: true },
          { text: "Nazwa konkursu", value: "contestName", sortable: true },
          {
            text: "Kraje realizacji",
            value: "realizationCountries",
            sortable: false,
          },
          {
            text: "Wartość projektu",
            value: "projectValue",
            sortable: false,
            width: "10%",
          },
          { text: "Dotacja", value: "donation", sortable: false, width: "10%" },
          {
            text: "Opiekun",
            value: "supervisorName",
            sortable: false,
            width: "10%",
          },
          { text: "Akcje", sortable: false },
        ],
        itemList: [],
        itemCount: 0,
        pagination: {
          rowsPerPage: 25,
          sortBy: null,
        },
      },
      dialogUserPrivillages: {
					show: false,
					headers: {
						name: "nazwa",
					},
					users: [],
					offerId: null,
				},
      dialogFinalReportUserPrivillages: {
					show: false,
					headers: {
						name: "nazwa",
					},
					users: [],
					offerId: null,
			},  
      loading: false,
      countryList: [],
      yearList: [],
      contestNameList: [],
      search: "",
      searchedFields: Pagination.initSearchedFields([
        "bidderId",
        "projectCode",
        "contestName",
        "realizationYear",
        "mainCountryId",
      ]),
      dialog: false,
      projectId: undefined,
      acceptedFiles: ".pdf,.zip",
      confirmationDialog: false,
    };
  },

  watch: {
    "dataTable.pagination": {
      handler(pagination) {
        this.buildNewSearch();
        this.paginationRef = pagination;
      },
      deep: true,
    },
  },

  props: {
    volunteer: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
tr td:first-of-type {
  white-space: nowrap;
}
</style>
